import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../interested_companies/loading.scss';
import InterestedCompanies from '../interested_companies/InterestedCompanies';

window.$ = $;
window.jQuery = $;

document.addEventListener('DOMContentLoaded', () => {
  Vue.component('InlineSvg', InlineSvg);

  const el = document.getElementById('app-interested-companies');
  if (!el) return;

  new Vue({
    el,
    render: (h) =>
      h(InterestedCompanies, {
        props: {
          companyId: Number(el.dataset.companyId),
          companyName: el.dataset.companyName,
          loginPath: el.dataset.loginPath,
        },
      }),
  });
});
